// extracted by mini-css-extract-plugin
export var closed = "_b6-1";
export var resizer = "_b6-0";